// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__vDPUR","label":"SetPasswdForm_label__kgwI_"};